import { APP_STORE_ID, GOOGLE_PLAY_PACKAGE_NAME } from "@/constant/common";
import { MixpanelEvent } from "@/constant/mixpanelEvent";
import { COOKIE_KEY, getCookie } from "@/lib/utils/cookies";
import { trackMixpanelEvent } from "@/lib/utils/trackEvent";

interface UseDownloadProps {
  downloadSource: string;
}

export const useDownload = ({ downloadSource }: UseDownloadProps) => {
  const handleAndroidDownloadClick = () => {
    trackMixpanelEvent(MixpanelEvent.DownloadAndroid, {
      download_source: downloadSource,
    });

    // 设置一个定时器，用于判断是否成功唤起了应用
    const startTime = Date.now();
    const timeout = setTimeout(function() {
        // 如果2秒后还在当前页面，说明唤起失败，跳转到网页版
        if (Date.now() - startTime > 1800) {
            window.location.href = 'https://play.google.com/store/apps/details?id=' + GOOGLE_PLAY_PACKAGE_NAME;
        }
    }, 2000);

    // 尝试唤起Google Play商店应用
    window.location.href = 'market://details?id=' + GOOGLE_PLAY_PACKAGE_NAME;

    // 检测页面是否失去焦点，如果是，说明成功跳转，清除定时器
    window.addEventListener('blur', function() {
        clearTimeout(timeout);
    });
  }

  const handleAppStoreClick = () => {
    const locale = getCookie(COOKIE_KEY.NEXT_LOCALE);
    let region = 'us'
    if (locale === 'ja') {
      region = 'jp'
    } else if (locale === 'zh') {
      region = 'cn'
    }
    // 构建App Store链接
    const appStoreUrl = `https://apps.apple.com/${region}/app/id${APP_STORE_ID}`
    trackMixpanelEvent(MixpanelEvent.DownloadIos, {
      download_source: downloadSource,
    });
    window.open(appStoreUrl, "_blank");
  }

  return {
    handleAppStoreClick,
    handleAndroidDownloadClick
  }
}